import React, { useState } from 'react';
import { Select, Input, Button, Divider } from 'antd';
import { PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { createAgendaTag } from '../../api/agendaTags';
import { NOTE_COLOR_OPTIONS } from '../../constants/agendaNoteColors';
import AgendaTagManageModal from './AgendaTagManageModal';

// Tag secimi + kullanicinin kendi tag'ini olusturabilmesi - Kullanicilar >
// Ozluk sekmesindeki "dosya tipi" secimiyle ayni "sec + yeni ekle" deseni.
// Ajanda'da tag'ler goreve (satira) atanir, bu yuzden bu bilesen hem
// filtrede hem olusturma/duzenleme formunda ayni sekilde kullaniliyor.
// Yeni eklenen tag'e otomatik siradaki sabit palet rengi atanir - renk
// sonradan "Yönet" ile degistirilebilir.
const AgendaTagSelect = ({ value, onChange, tags, setTags, placeholder = 'Tag seçin', allowClear = false, style }) => {
  const [newTagLabel, setNewTagLabel] = useState('');
  const [newTagColor, setNewTagColor] = useState(NOTE_COLOR_OPTIONS[0].value);
  const [addingTag, setAddingTag] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);

  const handleAddTag = async () => {
    const label = newTagLabel.trim();
    if (!label) return;
    setAddingTag(true);
    try {
      const res = await createAgendaTag(label, newTagColor);
      setTags((prev) => [...prev, res.data]);
      onChange(res.data.id);
      setNewTagLabel('');
      setNewTagColor(NOTE_COLOR_OPTIONS[(tags.length + 1) % NOTE_COLOR_OPTIONS.length].value);
    } catch (err) {
      message.error(err?.response?.data?.message || 'Tag eklenemedi.');
    } finally {
      setAddingTag(false);
    }
  };

  return (
    <>
      <div className="flex gap-1 items-center" style={{ ...style, width: style?.width }}>
        <Select
          value={value}
          onChange={onChange}
          allowClear={allowClear}
          placeholder={placeholder}
          style={{ flex: 1, minWidth: 0 }}
          popupMatchSelectWidth={280}
          dropdownRender={(menu) => (
            <>
              {menu}
              <Divider style={{ margin: '8px 0' }} />
              <div className="px-2 pb-2 flex flex-col gap-2">
                <Input
                  size="small"
                  placeholder="Yeni tag ekle"
                  value={newTagLabel}
                  onChange={(e) => setNewTagLabel(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                  maxLength={100}
                />
                <div className="flex gap-2 items-center flex-wrap">
                  {NOTE_COLOR_OPTIONS.map((c) => (
                    <span
                      key={c.value}
                      onClick={() => setNewTagColor(c.value)}
                      title={c.label}
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: '50%',
                        background: c.hex,
                        cursor: 'pointer',
                        display: 'inline-block',
                        boxSizing: 'border-box',
                        border: newTagColor === c.value ? '2px solid #333' : '2px solid transparent',
                      }}
                    />
                  ))}
                  <Button size="small" type="primary" icon={<PlusOutlined />} loading={addingTag} onClick={handleAddTag}>Ekle</Button>
                </div>
              </div>
            </>
          )}
        >
          {tags.map((t) => {
            const hex = NOTE_COLOR_OPTIONS.find((c) => c.value === t.color)?.hex || '#722ed1';
            return (
              <Select.Option key={t.id} value={t.id}>
                <span style={{ color: hex }}>●</span> {t.label}
              </Select.Option>
            );
          })}
        </Select>
        <Button
          size="middle"
          icon={<SettingOutlined />}
          onClick={() => setManageOpen(true)}
          title="Etiketleri Yönet"
        />
      </div>

      <AgendaTagManageModal
        open={manageOpen}
        onClose={() => setManageOpen(false)}
        tags={tags}
        setTags={setTags}
      />
    </>
  );
};

export default AgendaTagSelect;
